import { Box } from 'src/components/Box';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { Theme } from 'src/components/muiTheme/utils';
import { SxProps } from 'src/components/muiTheme/utils';

interface SubSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  spacing?: number;
  sx?: SxProps<Theme>;
}

export function SubSection({
  title,
  description,
  children,
  spacing = 2,
  sx,
}: SubSectionProps) {
  return (
    <Box sx={sx}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {description}
        </Typography>
      )}
      <Stack spacing={spacing}>{children}</Stack>
    </Box>
  );
}
